import resolveDependencies from './resolveDependencies';
import oclazyload from 'oclazyload';

const ngModule = angular.module('lb.bookingRoutes', [oclazyload]);

ngModule.run(bookingRouteEvents);
bookingRouteEvents.$inject = ['$rootScope', 'locationService'];
function bookingRouteEvents($rootScope, locationService) {
  // TODO migrate to onStart in each route and remove the segmentType data property after updating ui-router version
  $rootScope.$on('$stateChangeStart', (_, toState) => {
    if (toState.data && toState.data.segmentType) {
      locationService.updateCurrentSearchType(toState.data.segmentType);
    }
  });
}

ngModule.config(bookingRoutes);
bookingRoutes.$inject = ['$stateProvider'];
function bookingRoutes($stateProvider) {
  $stateProvider
    .state('app.booking', {
      abstract: true,
      template: '<ui-view/>',
      resolve: {
        itinerary: ['itinerariesService', (itinerariesService) => itinerariesService.lazyGet()],
        itinerarySearch: ['itinerariesService', (itinerariesService) => itinerariesService.getItinerarySearch()],
      },
    })
    .state('app.booking.segment', {
      abstract: true,
      template: '<ui-view/>',
      resolve: {
        searchSegment: [
          'itinerarySearch',
          'locationService',
          (itinerarySearch, locationService) => {
            const segment = locationService.getCurrentSearchSegment(itinerarySearch);
            if (segment == null) {
              throw new Error('Invalid Segment');
            }
            return segment;
          },
        ],
      },
    })
    .state('app.booking.segment.flights', {
      url: '/flights',
      params:{
        selectedItems: null,
      },
      template: '<lb-search-results search-type="\'Travel\'"></lb-search-results>',
      resolve: {
        resolveDependencies: resolveDependencies((resolve) =>
          require.ensure([], (require) => resolve(require('../components/lbSearchResults').name))
        ),
      },
      data: {
        pageTitle: 'Search Results - Flights',
        bodyClass: 'bg-flights',
        segmentType: 'Flight',
      },
    })
    .state('app.booking.segment.rail', {
      url: '/rail',
      template: '<lb-search-results search-type="\'Rail\'"></lb-search-results>',
      resolve: {
        resolveDependencies: resolveDependencies((resolve) =>
          require.ensure([], (require) => resolve(require('../components/lbSearchResults').name))
        ),
      },
      data: {
        pageTitle: 'Search Results - Rail',
        bodyClass: 'bg-rail',
        segmentType: 'Rail',
      },
    })
    .state('app.booking.segment.groundtransportation', {
      url: '/ground',
      resolve: {
        resolveDependencies: resolveDependencies((resolve) =>
          require.ensure([], (require) => resolve(require('./components/modifyGroundTransportation')))
        ),
      },
      template: `<lb-modify-ground-transportation search-segment="searchSegment" />`,
      controller: ['$scope', 'searchSegment', ($scope, searchSegment) => ($scope.searchSegment = searchSegment)],
      data: {
        pageTitle: 'Search Results - Ground Transportation',
        bodyClass: 'bg-cars',
        segmentType: 'GroundTransport',
      },
    })
    .state('app.booking.segment.cars', {
      url: '/cars',
      template: '<lb-search-results search-type="\'Cars\'"></lb-search-results>',
      resolve: {
        resolveDependencies: resolveDependencies((resolve) =>
          require.ensure([], (require) => resolve(require('../components/lbSearchResults').name))
        ),
      },
      data: {
        pageTitle: 'Search Results - Car',
        bodyClass: 'bg-cars',
        segmentType: 'Car',
      },
    })
    .state('app.booking.segment.hotels', {
      url: '/hotels',
      template: '<lb-search-results search-type="\'Hotels\'"></lb-search-results>',
      resolve: {
        resolveDependencies: resolveDependencies((resolve) =>
          require.ensure([], (require) => resolve(require('../components/lbSearchResults').name))
        ),
      },
      data: {
        bodyClass: 'bg-hotels',
        segmentType: 'Hotel',
      },
    })
    .state('app.booking.confirmation', {
      url: '/confirmation',
      template: '<lb-booking-confirmation></lb-booking-confirmation>',
      resolve: {
        resolveDependencies: resolveDependencies((resolve) =>
          require.ensure([], (require) => resolve(require('../components/lbBookingConfirmation').name))
        ),
      },
      data: {
        pageTitle: 'Booking Confirmation',
        bodyClass: 'bg-bookingConfirmation',
      },
    });
}

export default ngModule.name;



// WEBPACK FOOTER //
// ./src/routes/routes.booking.js